module.exports = __webpack_public_path__ + "img/page-title-bottom.02b79c6b.svg";